var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1146.6 1146.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0898e-5 621.06)",
    fill: "#333646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156.48-354.52c-86.283 0-156.48 70.194-156.48 156.48 0 76.848 55.724 140.79 128.86 153.89v191.62h-10.695v111.52h76.402v-111.52h-10.48v-191.62c73.138-13.098 128.86-77.043 128.86-153.89 0-86.283-70.194-156.48-156.48-156.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m990.12-354.52c-86.283 0-156.48 70.194-156.48 156.48 0 76.848 55.724 140.79 128.86 153.89v191.62h-10.695v111.52h76.402v-111.52h-10.48v-191.62c73.138-13.098 128.86-77.043 128.86-153.89 0-86.283-70.194-156.48-156.48-156.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.64 258.99h-152.8v-111.52h152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.76 258.99h-152.81v-111.52h152.81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.704b9a8e3bee63facecb86f975a470e4.svg";
export { ForwardRef as ReactComponent };